module.exports = __webpack_public_path__ + "img/311-5d71e5.png";